import Layout from "../../components/Layout/Layout";
import React, { useState, useEffect } from 'react';
import { PencilIcon, CheckIcon } from '@heroicons/react/outline';
import ApplicationSettServices from "../../services/ApplicationSettServices";
import fire from './../../utils/Toastr';
import { FormatMoneyWithoutCurrency } from "../../utils/formatMoney";


export default function ApplicationSettings() {
    const data = {
        applicationParameter: "DisablePlatform",
        isAvailable: true,
        applicationValue: ""
    };

    const [appSett, setAppSett] = useState([]);
    const [appValue, setAppValue] = useState({})
    const [formValue, setFormValues] = useState(data);
    const [user, setUser] = useState()

    const listAppMod = async () => {
        var details = sessionStorage.getItem("user");
        var user = JSON.parse(details);
        setUser(user)
        const resp = await ApplicationSettServices.listAppSetting();
        setAppSett([...resp.data]);
    }

    const handleSett = async (e) => {
        setFormValues({
            ...formValue, applicationValue: e
        });
    }

    const edit = async (rate) => {
        setAppValue(rate);
        setFormValues({
            applicationValue: rate.applicationValue
        })
    }
    const update = async (sett) => {
       
        const data = {
            applicationParameter: sett.applicationParameter,
            applicationValue: formValue.applicationValue
        }
        const resp = await ApplicationSettServices.updateSetting(data);
        if (resp) {
            fire("success", resp.message);
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        }


        // if (user.adminType === "0") {

        //     if (sett.applicationSettingStatus !== "initiated") {
        //         const data = {
        //             applicationParameter: sett.applicationParameter,
        //             applicationValue: formValue.applicationValue
        //         }
        //         const resp = await ApplicationSettServices.updateSetting(data);
        //         if (resp) {
        //             fire("success", resp.message);
        //             setTimeout(() => {
        //                 window.location.reload();
        //             }, 5000);

        //         }
        //     }else{
        //         fire("error", "This mode is not available for approval")
        //     }
        // }else if (user.adminType === "1") {
        //     if (sett.applicationSettingStatus === "initiated") {
        //         const data = {
        //             applicationParameter: sett.applicationParameter,
        //             applicationValue: formValue.applicationValue,
        //             applicationSettingsStatus: "Initiated"
        //         }
        //         const resp = await ApplicationSettServices.updateSetting(data);
        //         if (resp) {
        //             fire("success", resp.message);
        //             setTimeout(() => {
        //                 window.location.reload();
        //             }, 5000);                   
        //         }
        //     }else{
        //         fire("error", "Maker approval is required first")
        //     }
        // }


    }
    useEffect(() => {
        listAppMod();
    }, [])
    return (
        <>
            <Layout title={"Application Settings"} pageTag={"application_settings"} current={"/application/settings"}>
                <React.Fragment>
                    <main>
                        <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                            <div className="px-4 sm:px-6 lg:px-8">
                                <div className="mt-8 flex flex-col">

                                    {/* form */}
                                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                                        {appSett.map((option, i) => (
                                            <>
                                                {option.optionType.toLowerCase() === "input" ?
                                                    <>
                                                        <div className='mt-6 col-span-1 bg-white rounded-lg  divide-y divide-gray-200' key={i} >
                                                            <div>
                                                                <label htmlFor="title" className="block text-sm font-medium text-gray-700">
                                                                    {option.settingsName}
                                                                </label>
                                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                                    <div className="relative flex items-stretch flex-grow focus-within:z-10">
                                                                        {appValue.applicationParameter !== option.applicationParameter ?
                                                                            <div
                                                                                name="email"
                                                                                className="input_layer focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-2 sm:text-sm border-gray-300"
                                                                                placeholder="John Smith"
                                                                            > {isNaN(option.applicationValue) === true ? option.applicationValue : FormatMoneyWithoutCurrency(option.applicationValue)}</div> :
                                                                            <input
                                                                                type="text"
                                                                                name="applicationValue"
                                                                                id="email"
                                                                                value={formValue.applicationValue}
                                                                                onChange={(e) => handleSett(e.target.value)}
                                                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-none rounded-l-md pl-10 sm:text-sm border-gray-300"
                                                                                placeholder={option.applicationValue}
                                                                            />
                                                                        }

                                                                    </div>
                                                                    {user.roleName.toLowerCase() !== "superadmin" ? "" :
                                                                        <>
                                                                            {appValue.applicationParameter !== option.applicationParameter ?
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => edit(option)}
                                                                                    className="-ml-px bg-black relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700  hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                                                                >
                                                                                    <PencilIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                                </button> :
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => update(option)}
                                                                                    className="-ml-px bg-black relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700  hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                                                                                >
                                                                                    <CheckIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                                </button>
                                                                            }
                                                                        </>}

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </> : <>

                                                        {/* <select>
                                                    <option></option>
                                                </select> */}
                                                    </>}
                                            </>


                                        ))}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </main>

                </React.Fragment>
            </Layout>
        </>
    )
}